<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card no-shadow mt-0">
            <div class="card-header card-header-primary negative blue-grad w-50 d-flex">
              <router-link v-if="!is_bank" class="btn btn-outline-primary btn-sm mr-3"
                :to="{ name: 'contragents-search-index' }"><i class="fa fa-chevron-left mr-2"></i>{{ $t("message.back")
                }}</router-link>
              <h4 v-if="services.length > 1" class="card-title">
                {{ $t("message.find_partner.group_search") }}
              </h4>
              <h4 v-else class="card-title">
                {{ $t("message.contragent_search.enterprise_risk_scan") }}
              </h4>
            </div>
            <div class="card-body">
              <b-tabs pills content-class="mt-3" small v-model="current_tab">
                <b-tab :title="$t('message.find_partner.search_button')" active id="search-tab">
                  <div v-if="services.includes('736')" class="row-">
                    <div class="col-md-60-">
                      <div class="d-flex align-items-center dedede">
                        <div class="icon">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M13.6041 12.4159L18.0875 16.8993C18.2451 17.057 18.3335 17.2708 18.3335 17.4937C18.3334 17.7167 18.2447 17.9304 18.0871 18.088C17.9294 18.2456 17.7155 18.3341 17.4926 18.334C17.2697 18.3339 17.0559 18.2453 16.8983 18.0876L12.415 13.6043C11.0747 14.6423 9.38937 15.1308 7.70174 14.9704C6.01412 14.81 4.451 14.0126 3.33037 12.7406C2.20975 11.4686 1.61579 9.81746 1.66935 8.12307C1.7229 6.42868 2.41993 4.81833 3.61864 3.61962C4.81735 2.4209 6.4277 1.72387 8.12209 1.67032C9.81648 1.61677 11.4676 2.21072 12.7396 3.33135C14.0117 4.45197 14.809 6.01509 14.9694 7.70272C15.1299 9.39034 14.6414 11.0757 13.6033 12.4159H13.6041ZM8.3333 13.3334C9.65938 13.3334 10.9312 12.8067 11.8688 11.869C12.8065 10.9313 13.3333 9.65953 13.3333 8.33345C13.3333 7.00736 12.8065 5.73559 11.8688 4.79791C10.9312 3.86023 9.65938 3.33345 8.3333 3.33345C7.00722 3.33345 5.73545 3.86023 4.79777 4.79791C3.86009 5.73559 3.3333 7.00736 3.3333 8.33345C3.3333 9.65953 3.86009 10.9313 4.79777 11.869C5.73545 12.8067 7.00722 13.3334 8.3333 13.3334Z"
                              fill="#8D8D8D" />
                          </svg>
                        </div>
                        <input type="text" class="form-control" id="keyWord886" v-model="keyWord886"
                          :placeholder="$t('message.find_partner.search_keyword_placeholder')" autocomplete="off"
                          style="cursor: auto" />
                        <button :class="[
                          'btn',
                          'btn-success',
                          'btn-round',
                          'btn-sm',
                          'position-relative',
                        ]" @click="searchServices" id="init_search_china" :disabled="isSearchButtonDisabled || !keyWord886">
                          {{ $t("message.find_partner.search_button") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="services.includes('213') && !is_bank" class="row px-5">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                      <br />
                      <span :class="['form-group']">
                        <label for="provinceCode">{{
                          $t("message.find_partner.province_code_keyWord")
                        }}</label>
                        <input type="text" class="form-control" id="provinceCode" v-model="provinceCode" :placeholder="$t('message.find_partner.province_code_keyWord')
                          " autocomplete="off" style="cursor: auto" />
                      </span>
                    </div>
                  </div>
                  <div v-if="services.includes('213') && !is_bank" class="row px-5">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                      <br />
                      <span :class="['form-group']">
                        <label for="cityCode">{{
                          $t("message.find_partner.city_code_keyword")
                        }}</label>
                        <input type="text" class="form-control" id="cityCode" v-model="cityCode" :placeholder="$t('message.find_partner.city_code_keyword')
                          " autocomplete="off" style="cursor: auto" />
                      </span>
                    </div>
                  </div>
                  <div v-if="loading > 0" style="position: relative; height: 100px">
                    <!-- <div class="loading"></div> -->
                    <!-- <div class="text-center"> {{$t('message.find_partner.load_in_progress')}}</div> -->

                    <div class="row">
                      <div class="col-md-2"></div>
                      <div class="col-md-8">
                        <b-progress :value="total_loaded" :max="services.length * 3 + 1" show-progress
                          animated></b-progress>
                      </div>
                    </div>
                    <div class="text-center">
                      {{ timer_minutes }}:{{ timer_seconds }}
                    </div>
                    <div class="text-center" v-if="locale == 'ru' && total_loaded == 1">
                      {{
                        $t(
                          "message.find_partner.services_parameter_translation",
                        )
                      }}
                    </div>
                    <div v-for="(srvc, i) in services_loading">
                      <div class="text-center">
                        {{ $t("message.find_partner.service_" + srvc.service) }}
                        {{ $t("message.find_partner.services_loading") }}
                      </div>
                      <div class="text-center" v-if="srvc.loading_step == 1">
                        {{ $t("message.find_partner.services_loading_data") }}
                      </div>
                      <div class="text-center" v-if="srvc.loading_step == 2">
                        {{
                          $t(
                            "message.find_partner.services_loading_translations",
                          )
                        }}
                      </div>
                      <div class="text-center" v-if="srvc.loading_step == 3">
                        {{ $t("message.find_partner.services_rendering") }}
                      </div>
                    </div>
                  </div>

                  <div v-if="loading == 0" class=" d-flex py-5">
                    <div class="d-flex ml-auto" style="gap: 10px">
                      <pdf  :user_id="0" :document="pdf_document" :doc_additional="pdf_parameters" :goods="services" :doc_id="0" source="enterprise-risk-scan-cn-full"></pdf>
                    </div>
                </div>

                  <enterprise-fuzzy-service-cn v-if="enterprise_fuzzy_complete && loading == 0"
                    :data="business_fuzzy_info" :progress="progress_fuzzy"></enterprise-fuzzy-service-cn>
                  <tmp-company-info-service-cn v-if="search_company_info_complete && loading == 0"
                    :data="company_info_data"></tmp-company-info-service-cn>
                  <tmp-court-info-service-cn v-if="court_search_complete && loading == 0"
                    :data="court_info_data"></tmp-court-info-service-cn>
                  <tmp-company-news-service-cn v-if="news_search_complete && loading == 0"
                    :data="news_info_data"></tmp-company-news-service-cn>
                  <tmp-risk-scan-cn-full v-if="risk_search_complete && loading == 0"
                    :data="risk_info_data"></tmp-risk-scan-cn-full>
                  <tmp-annual-report-service-cn v-if="anual_search_complete && loading == 0"
                    :data="annual_info_data"></tmp-annual-report-service-cn>

                  <div v-if="loading == 0 && services.length === no_result" class="mt-3 text-center pb-3 alert"
                    id="no-results-doc">
                    <div class="card">
                      <div class="card-body">
                        <div class="position-relative">
                          <h2 class="text-center">
                            Attis {{ $t("message.find_partner.find_partner") }}
                          </h2>
                          <button class="btn btn-outline-primary position-absolute" style="right: 0; top: 0"
                            @click="makePdf">
                            {{ $t("message.find_partner.download_pdf") }}
                          </button>
                        </div>
                        <h4 class="text-center">
                          {{ $t("message.find_partner.search_certificate") }}
                        </h4>
                        <div class="text-left">
                          {{ $t("message.find_partner.search_query") }}:
                          {{ keyWord }}
                        </div>
                        <div class="text-left">
                          {{ $t("message.find_partner.request_from") }}:
                          {{ user_full_name }}
                        </div>
                        <div class="text-left">
                          {{ $t("message.find_partner.request_date") }}:
                          {{ momentum_now() }}
                        </div>
                        <div class="text-left">
                          {{ $t("message.find_partner.no_matches_line") }}
                        </div>
                        <h4 class="mt-3 text-left">
                          {{ $t("message.find_partner.search_results") }}
                        </h4>
                        <div class="text-left" style="
                            border: 1px solid #ccc;
                            padding: 15px;
                            border-radius: 5px;
                          ">
                          {{ $t("message.find_partner.found_matches") }}:
                          <span class="badge bg-primary"> 0 </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <!-- <b-tab :title="$t('message.find_partner.history')" lazy id="case-management-tab">
                  <CNSearchHistory />
                </b-tab> -->
              </b-tabs>
            </div>
          </div>

          <find-partner-docs v-if="locale_ == 'ru-RU'" />
          <find-partner-docs-en v-if="locale_ == 'en-US'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import translatableField from "../../fields/translatable-field.vue";
import html2pdf from "html2pdf.js";
import CNSearchHistory from "../../contracts/contragent-search/helpers/history.vue";
export default {
  components: { translatableField, CNSearchHistory },
  data() {
    return {
      isSearchButtonDisabled: false,

      history_record_id: false,

      traffic_light: [],

      global_log: {},
      global_log_cn: {},
      global_kw: "",
      formatted_kw: "",

      user_balance: 0,

      loading: -1,
      search_company_info_complete: false,
      court_search_complete: false,
      news_search_complete: false,
      risk_search_complete: false,
      anual_search_complete: false,
      enterprise_fuzzy_complete: false,
      current_tab: 0,
      no_result: 0,
      services_loading: [],
      total_loaded: 0,

      tmp_company_info_for_helpers: {
        EnglishName: "",
        Email: "",
      },

      company_info_data: {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      },
      court_info_data: {
        response_info: {},
      },
      news_info_data: {
        response_info: {},
      },
      risk_info_data: {
        Industry: {},
        Area: {},
        RevokeInfo: {},
        Penalty: [],
        Exceptions: [],
        ShiXinItems: [],
        ZhiXingItems: [],
        MPledge: [],
        Pledge: [],
        SpotCheck: [],
        CompanyTaxCreditItems: [],
        CompanyProducts: [],
        PermissionEciInfo: [],
        PenaltyCreditChina: [],
        Partners: [],
        Employees: [],
        Branches: [],
        ChangeRecords: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalName: [],
        ContactInfo: {},
      },
      business_fuzzy_info: {
        response_info: {},
        Paging: {},
        currency: "",
        price: 0,
      },
      annual_info_data: {},
      keyWord: "",
      keyWordTranslated: "",
      keyWord886: "",
      keyWord886Translated: "",
      pdf_document: {},
      services: [],
      prices: {},
      currency: "",
      service_codes: [
        {
          value: "430",
          display_text: this.$t("message.find_partner.common_info_cn"),
        },
        {
          value: "930",
          display_text: this.$t("message.find_partner.court_notice_info"),
        },
        {
          value: "701",
          display_text: this.$t("message.find_partner.corporate_news_search"),
        },
        {
          value: "213",
          display_text: this.$t("message.contragent_search.annual_report"),
        },
        {
          value: "736",
          display_text: this.$t(
            "message.contragent_search.enterprise_risk_scan",
          ),
        },
        {
          value: "886",
          display_text: this.$t("message.find_partner.fuzzy_search_cn"),
        },
      ],
      provinceCode: "",
      provinceCodeTranslated: "",
      cityCode: "",
      cityCodeTranslated: "",
      pdf_parameters: {},
      timer_seconds: "00",
      timer_minutes: "00",
      interval: "",
      locale: "",
      progress_fuzzy: -1,
      reduceBalanceId: null,
      servicesHasResults: { "736": null },
    };
  },
  mounted() {
    this.doMount();
  },

  methods: {
    makePdf() {
      var element = document.getElementById("no-results-doc");
      var opt = {
        margin: [0.2, 0.1, 0.2, 0.1],
        filename: "Document_PS_no_match.pdf",
        enableLinks: true,
        //pagebreak:    { mode: 'css', avoid: 'p' },
        pagebreak: { mode: ["avoid-all", "css"] },
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      window.scrollTo(0, 0);
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
          }
        })
        .save();
    },
    hasResults(serviceCode, hasResults) {
      this.servicesHasResults[serviceCode] = hasResults;

      if (Object.values(this.servicesHasResults).find(Boolean)) {
        let fd = new FormData();
        fd.append("id", this.reduceBalanceId);
        fd.append("hasResults", true);
        this.reduceBalanceId && axios.post(window.base + "/account/updateOperationResult", fd);
        this.reduceBalanceId = null;
        this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
      }
      if (Object.values(this.servicesHasResults).every((v) => v === false)) {
        let fd = new FormData();
        fd.append("id", this.reduceBalanceId);
        fd.append("hasResults", false);
        this.reduceBalanceId && axios.post(window.base + "/account/updateOperationResult", fd);
        this.reduceBalanceId = null;
        this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
      }
    },
    doMount() {
      if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
      window.is_searched = false;
      if (this.is_bank) {
        this.services = ["736"];
        this.servicesHasResults = { "736": null };
        this.prices = {};
        this.currency = {};
        this.loadPrices();
      } else {
        this.services = this.$route.params.services;
        this.servicesHasResults = Object.assign({}, ...this.services.map((service) => ({ [service]: null })));
        this.prices = this.$route.params.prices;
        this.currency = this.$route.params.currency;
        this.loadPrices();
      }
      this.$root.$on("load-fuzzy-new-page", (reduceBalanceId) => {
        console.log("load-fuzzy-new-page");
        this.reduceBalanceId = reduceBalanceId;
        this.servicesHasResults = { "736": null };
        this.searchenterpriseFuzzy("new-page");
      });

      if (
        this.$route.params &&
        this.$route.params.search &&
        this.$route.params.search !== ""
      ) {
        this.keyWord886 = this.$route.params.search;
        this.searchServices();
      }

      if (
        this.$route.name == "find-partner-info-hist-tab" ||
        this.$route.name == "cs-single"
      ) {
        this.current_tab = 1;
      }
    },
    loadPrices() {
      this.prices = {};
      axios
        .get(window.base + "/account/GetServicesPrice")
        .then((response) => {
          this.services.forEach((key) => {
            if (typeof response.data == "object") {
              var r = response.data.find(
                (element) => element.billing_service_code === key,
              );
              this.currency = r.billing_service_cur;
              if (this.$store.state.user.is_privileged)
                this.prices[key] = r.service_price_privileged;
              else this.prices[key] = r.billing_service_price;
            }
          });
        })
        .catch(() => {
          console.log("Error loading pricelist...");
        });
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    momentum_now(d) {
      return moment().format("D.MM.Y");
    },
    translateText(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        axios
          .get(
            window.base +
            "/translate/TranslateNext?text=" +
            text +
            "&source=zh&target=" +
            locale,
          )
          .then((response) => {
            return response.data.translation;
          });
      } else {
        return text;
      }
    },
    translateTextArray(text, service_code) {
      console.log("translateTextArray");
      console.table(text);
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        let url = `${window.base}/translate/TranslateNextArray?source=zh&target=${locale}`;

        if (service_code) {
          url += `&service_code=${service_code}`;
        }

        return axios.post(url, text);
      }
    },
    translateTextArrayOfArrays(array) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/translate/TranslateNextMultiArray?source=zh&target=" +
          locale,
          array,
        );
      }
    },
    async formatObjects(object, list) {
      console.log("formatObjects");
      console.table(object);
      return this.translateTextArray(object).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          list[i].push(JSON.parse(res.data[i]).translation);
        }
        this.company_info_data.service_info = list;
      });
    },
    // formats table data with translations
    async formatObjectTablesCompany(object, list) {
      console.log("formatObjectTables");
      console.table(object);
      console.table(Object.keys(object));
      console.table(Object.values(object));
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values)
          .then((res) => {
            res.data.forEach((t, i) => {
              if (
                keys[i] === "CreditCode" ||
                keys[i] === "No" ||
                keys[i] === "IndustryCode" ||
                keys[i] === "SubIndustryCode"
              )
                list.push({
                  Key: keys[i],
                  Translated: values[i],
                  Original: values[i],
                });
              else
                list.push({
                  Key: keys[i],
                  Translated: JSON.parse(t).translation,
                  Original: values[i],
                });
            });
          })
          .catch((e) => {
            //console.log('catch formatObjectTables', e)
            //console.log(object);
            return false;
          });
      } else return true;
    },
    async formatArrayObjectTables(object, list, service_code) {
      if (object.length > 0) {
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values, service_code)
            .then((res) => {
              var translated = {};
              for (let j = 0; j < res.data.length; j++) {
                if (
                  keys[j] === "CreditCode" ||
                  keys[j] === "No" ||
                  keys[j] === "IndustryCode" ||
                  keys[j] === "SubIndustryCode"
                )
                  translated[keys[j]] = values[j];
                else translated[keys[j]] = JSON.parse(res.data[j]).translation;
              }
              list.push(translated);
            })
            .catch(() => {
              return false;
            });
        }
      } else return true;
    },
    async formatObjectTables(object, resObject) {
      console.log("formatObjectTables");
      console.table(object);
      console.table(Object.keys(object));
      console.table(Object.values(object));
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values).then((res) => {
          res.data.forEach((t, i) => {
            if (
              keys[i] === "CreditCode" ||
              keys[i] === "No" ||
              keys[i] === "IndustryCode" ||
              keys[i] === "SubIndustryCode" ||
              keys[i] == "No" ||
              keys[i] == "Year" ||
              keys[i] == "PublishDate"
            )
              resObject[keys[i]] = values[i];
            else resObject[keys[i]] = JSON.parse(t).translation;
          });
        });
      } else return true;
    },
    async formatArrayObjectTablesAnnual(object, list, object_type = "wrong") {
      if (object.length > 0) {
        list = [];
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              if (
                keys[j] === "CreditCode" ||
                keys[j] === "No" ||
                keys[j] === "IndustryCode" ||
                keys[j] === "SubIndustryCode" ||
                keys[i] == "No" ||
                keys[i] == "Year" ||
                keys[i] == "PublishDate"
              )
                translated[keys[j] + "Translated"] = values[j];
              else
                translated[keys[j] + "Translated"] = JSON.parse(
                  res.data[j],
                ).translation;
            }
            list.push(translated);
          });
        }
      } else return true;
    },

    formatStringValues(values, keys) {
      var locale = this.$i18n.locale;

      this.translateTextArray(values).then((res) => {
        res.data.forEach((r, i) => {
          if (locale !== "cn")
            this.risk_info_data[keys[i]] = JSON.parse(r).translation;
          else this.risk_info_data[keys[i]] = values[i];
        });
      });
    },

    async makeBulkTranslation({ objects, tables, object_tables, strings }) {
      console.warn("bulk input", objects, tables, object_tables);
      const request = [];
      const request_tmp = [];
      if (typeof objects[0] !== "undefined") {
        objects.forEach((item) => request.push(Object.values(item).map(item => {
          if (typeof item != 'object') {
            return item;
          } else {
            return "";
          }
        })));
      }
      if (typeof tables[0] !== "undefined") {
        tables.forEach((item) => {
          const values = Object.values(item).map(item => {
            if (typeof item != 'object') {
              return item;
            } else {
              return "";
            }
          });
          if (values.length > 0) request.push(values);
        });
      }
      if (typeof object_tables[0] !== "undefined") {
        object_tables.forEach((table) => {
          if (Array.isArray(table)) {
            table.forEach((object) => {
              const values = Object.values(object).map(item => {
                if (typeof item != 'object') {
                  return item;
                } else {
                  return "";
                }
              });
              if (values.length > 0) request.push(values);
            });
          }
        });
      }
      if (typeof strings[0] !== "undefined") {
        strings.forEach((object) => {
          request.push(object.stringValues);
        });
      }

      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        const objects_translated = [];
        const tables_translated = [];
        const object_tables_translated = [];

        const response = await axios.post(
          window.base +
          "/library/TranslateNextMultiArray?source=zh&target=" +
          locale,
          request,
        );
        let global_counter = 0;

        const data = response.data;
        console.log(request, data);
        if (typeof objects[0] !== "undefined") {
          objects.forEach((item, index) => {
            objects_translated.push(
              response.data[global_counter].map(
                (translated) => JSON.parse(translated).translation,
              ),
            );
            global_counter++;
          });
        }
        if (typeof tables[0] !== "undefined") {
          tables.forEach((item, index) => {
            const values = Object.values(item);
            if (values.length > 0) {
              const keys = Object.keys(item);
              console.log("kekekey", keys);
              const translated_object = [];
              response.data[global_counter].forEach((t, i) => {
                if (
                  keys[i] === "CreditCode" ||
                  keys[i] === "No" ||
                  keys[i] === "IndustryCode" ||
                  keys[i] === "SubIndustryCode" /*|| keys[i]=='Year'*/ ||
                  keys[i] == "PublishDate"
                ) {
                  translated_object.push({
                    Key: keys[i],
                    Translated: values[i],
                    Original: values[i],
                  });
                } else {
                  translated_object.push({
                    Key: keys[i],
                    Translated: JSON.parse(t).translation,
                    Original: values[i],
                  });
                }
              });
              global_counter++;
              tables_translated.push(translated_object);
            } else {
              tables_translated.push(item);
            }
          });
        }
        console.log("tables_translated", tables_translated);
        console.log("ot", object_tables);
        if (typeof object_tables[0] !== "undefined") {
          object_tables.forEach((object) => {
            const translated_object_table = [];
            console.log("objt", object);
            if (Array.isArray(object)) {
              object.forEach((item) => {
                const values = Object.values(item);
                console.warn(
                  "trans",
                  global_counter,
                  response.data[global_counter],
                );
                if (values.length > 0) {
                  const keys = Object.keys(item);
                  const translated_object = {};
                  keys.forEach((key, key_index) => {
                    console.log("keyj", key);
                    if (
                      typeof response.data[global_counter] !== "undefined" &&
                      Array.isArray(response.data[global_counter])
                    )
                      if (
                        typeof response.data[global_counter][key_index] !==
                        "undefined"
                      ) {
                        try {
                          translated_object[key] = JSON.parse(
                            response.data[global_counter][key_index],
                          ).translation;
                        } catch (e) {
                          console.log(e)
                        }
                      }
                  });

                  translated_object_table.push(translated_object);
                } else {
                  translated_object_table.push(item);
                }
                global_counter++;
              });
            }
            object_tables_translated.push(translated_object_table);
          });
        }
        console.log("ot_", object_tables_translated);
        const strings_translated = [];
        if (typeof strings[0] !== "undefined") {
          strings.forEach((object) => {
            const tmp_object = {};

            object.stringKeys.forEach((key, i) => {
              if (Array.isArray(response.data[global_counter]))
                tmp_object[key] = JSON.parse(
                  response.data[global_counter][i],
                ).translation;
            });
            strings_translated.push(tmp_object);
            global_counter++;
          });
        }

        console.warn(
          objects_translated.length,
          tables_translated.length,
          object_tables_translated.length,
        );
        return {
          objects: objects_translated,
          tables: tables_translated,
          object_tables: object_tables_translated,
          strings: strings_translated,
        };
        // })
      }
      return { objects, tables, object_tables, strings };
    },

    async getCompanyInfoTranslations(
      service_to_translate,
      tmp_service_info,
      tmp_response_info,
    ) {
      return new Promise(async (resolve, reject) => {
        const {
          objects: [service_info],
          tables: [areaList, industryList, revokeInfoList, parentInfoList],
          object_tables: [
            EntTagList,
            ChangeList,
            UsedNameList,
            ShareHolderList,
            EmployeeList,
            InvestList,
            BranchList,
            MoreEmailList,
          ],
        } = await this.makeBulkTranslation({
          objects: [service_to_translate],
          tables: [
            tmp_response_info.Area,
            tmp_response_info.Industry,
            tmp_response_info.RevokeInfo,
            tmp_response_info.ParentInfo,
          ],
          object_tables: [
            tmp_response_info.EntTagList,
            tmp_response_info.ChangeList,
            tmp_response_info.UsedNameList,
            tmp_response_info.ShareHolderList,
            tmp_response_info.EmployeeList,
            tmp_response_info.InvestList,
            tmp_response_info.BranchList,
            tmp_response_info.MoreEmailList,
          ],
          strings: [],
        });
        // console.log(data)
        let real_service_info = [];
        real_service_info = tmp_service_info.map((item, index) => {
          return [item[0], item[1], service_info[index]];
          // return item
        });
        // 91110105599635386M

        this.$set(this.company_info_data, "service_info", real_service_info);
        this.$set(this.company_info_data, "areaList", areaList);
        this.$set(this.company_info_data, "industryList", industryList);
        this.$set(this.company_info_data, "revokeInfoList", revokeInfoList);
        this.$set(this.company_info_data, "parentInfoList", parentInfoList);

        this.$set(this.company_info_data, "EntTagList", EntTagList);
        this.$set(this.company_info_data, "ChangeList", ChangeList);
        this.$set(this.company_info_data, "UsedNameList", UsedNameList);
        this.$set(this.company_info_data, "ShareHolderList", ShareHolderList);
        this.$set(this.company_info_data, "EmployeeList", EmployeeList);
        this.$set(this.company_info_data, "InvestList", InvestList);
        this.$set(this.company_info_data, "BranchList", BranchList);
        this.$set(this.company_info_data, "MoreEmailList", MoreEmailList);
        resolve();
      });
    },
    async getRiskScanTranslations(response, stringValues, stringKeys) {
      return new Promise(async (resolve, reject) => {
        const {
          objects: [],
          tables: [Industry, Area, RevokeInfo, ContactInfo],
          object_tables: [
            Penalty,
            Exceptions,
            ShiXinItems,
            ZhiXingItems,
            MPledge,
            Pledge,
            SpotCheck,
            CompanyTaxCreditItems,
            CompanyProducts,
            PermissionEciInfo,
            PenaltyCreditChina,
            Partners,
            Employees,
            Branches,
            ChangeRecords,
            EmergingIndusty,
            TagList,
            ARContactList,
            OriginalName,
          ],
          strings: [strings],
        } = await this.makeBulkTranslation({
          objects: [],
          tables: [
            response.data.Result.Industry,
            response.data.Result.Area,
            response.data.Result.RevokeInfo,
            response.data.Result.ContactInfo,
          ],
          object_tables: [
            response.data.Result.Penalty,
            response.data.Result.Exceptions,
            response.data.Result.ShiXinItems,
            response.data.Result.ZhiXingItems,
            response.data.Result.MPledge,
            response.data.Result.Pledge,
            response.data.Result.SpotCheck,
            response.data.Result.CompanyTaxCreditItems,
            response.data.Result.CompanyProducts,
            response.data.Result.PermissionEciInfo,
            response.data.Result.PenaltyCreditChina,
            response.data.Result.Partners,
            response.data.Result.Employees,
            response.data.Result.Branches,
            response.data.Result.ChangeRecords,
            response.data.Result.EmergingIndustyList,
            response.data.Result.TagList,
            response.data.Result.ARContactList,
            response.data.Result.OriginalName,
          ],
          strings: [{ stringValues, stringKeys }],
        });
        console.log(strings);
        Object.keys(strings).forEach((key) => {
          this.$set(this.risk_info_data, key, strings[key]);
        });
        this.$set(this.risk_info_data, "Industry", Industry);
        this.$set(this.risk_info_data, "Area", Area);
        this.$set(this.risk_info_data, "RevokeInfo", RevokeInfo);
        this.$set(this.risk_info_data, "ContactInfo", ContactInfo);
        this.$set(this.risk_info_data, "Penalty", Penalty);
        this.$set(this.risk_info_data, "Exceptions", Exceptions);
        this.$set(this.risk_info_data, "ShiXinItems", ShiXinItems);
        this.$set(this.risk_info_data, "ZhiXingItems", ZhiXingItems);
        this.$set(this.risk_info_data, "MPledge", MPledge);
        this.$set(this.risk_info_data, "Pledge", Pledge);
        this.$set(this.risk_info_data, "SpotCheck", SpotCheck);
        this.$set(
          this.risk_info_data,
          "CompanyTaxCreditItems",
          CompanyTaxCreditItems,
        );
        this.$set(this.risk_info_data, "CompanyProducts", CompanyProducts);
        this.$set(this.risk_info_data, "PermissionEciInfo", PermissionEciInfo);
        this.$set(
          this.risk_info_data,
          "PenaltyCreditChina",
          PenaltyCreditChina,
        );
        this.$set(this.risk_info_data, "Partners", Partners);
        this.$set(this.risk_info_data, "Employees", Employees);
        this.$set(this.risk_info_data, "Branches", Branches);
        this.$set(this.risk_info_data, "ChangeRecords", ChangeRecords);
        this.$set(this.risk_info_data, "EmergingIndusty", EmergingIndusty);
        this.$set(this.risk_info_data, "TagList", TagList);
        this.$set(this.risk_info_data, "ARContactList", ARContactList);
        this.$set(this.risk_info_data, "OriginalName", OriginalName);
        resolve();
      });
    },
    getAnnualTranslations(result) {
      return new Promise((resolve, reject) => {
        const result_ = [];
        result.map((res, index) => {
          this.makeBulkTranslation({
            objects: [],
            tables: [res.BasicInfoData, res.AssetsData, res.SocialInsurance],
            object_tables: [
              res.ChangeList,
              res.InvestInfoList,
              res.PartnerList,
              res.ProvideAssuranceList,
              res.StockChangeList,
              res.WebSiteList,
              res.AdministrationLicenseList,
              res.BranchList,
              res.EmployeeList,
            ],
            strings: [],
          }).then(
            ({
              objects: [],
              tables: [BasicInfoData_, AssetsData_, SocialInsurance_],
              object_tables: [
                ChangeList_,
                InvestInfoList_,
                PartnerList_,
                ProvideAssuranceList_,
                StockChangeList_,
                WebSiteList_,
                AdministrationLicenseList_,
                BranchList_,
                EmployeeList_,
              ],
            }) => {
              console.warn(PartnerList_);
              console.warn({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              result_.push({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              console.warn(result_);
              if (index == result.length - 1) {
                resolve(result_);
              }
            },
          );
        });
      });
    },
    requestServices() {
      if (this.services.includes("430"))
        //companyinfo
        this.searchCompanyInfo();
      if (this.services.includes("930"))
        // court
        this.searchCourtInfo();
      if (this.services.includes("701"))
        // news
        this.searchNewsInfo();
      if (this.services.includes("213"))
        // annual
        this.searchAnnualInfo();

      if (this.services.includes("736"))
        // risk
        this.searchRiskScanInfo();
      if (this.services.includes("886"))
        // enterprisefuzzy
        this.searchenterpriseFuzzy("1");
    },
    disableSearchForSomeTime() {
      new Noty({
        type: "success",
        theme: "light",
        text: this.$t("message.request_processing"),
        timeout: 5000,
        progressBar: true,
      }).show();
      this.isSearchButtonDisabled = true;
      setTimeout(() => {
        this.isSearchButtonDisabled = false;
      }, 20000);
    },
    async searchServices() {
      this.company_info_data = {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      };

      this.annual_info_data = {};
      this.pdf_document = {};

      this.court_info_data = {
        response_info: {},
      };
      this.news_info_data = {
        response_info: {},
      };
      this.risk_info_data = {
        Industry: {},
        Area: {},
        RevokeInfo: {},
        Penalty: [],
        Exceptions: [],
        ShiXinItems: [],
        ZhiXingItems: [],
        MPledge: [],
        Pledge: [],
        SpotCheck: [],
        CompanyTaxCreditItems: [],
        CompanyProducts: [],
        PermissionEciInfo: [],
        PenaltyCreditChina: [],
        Partners: [],
        Employees: [],
        Branches: [],
        ChangeRecords: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalName: [],
        ContactInfo: {},
      };
      this.business_fuzzy_info = {
        response_info: {},
        Paging: {},
        currency: "",
        price: 0,
      };

      this.no_result = 0;
      this.services_loading = [];
      this.total_loaded = 0;

      this.loading = -1;

      this.search_company_info_complete = false;
      this.court_search_complete = false;
      this.news_search_complete = false;
      this.risk_search_complete = false;
      this.anual_search_complete = false;
      this.enterprise_fuzzy_complete = false;

      this.pdf_parameters.keyWord = this.keyWordTranslated;
      this.pdf_parameters.keyWord886 = this.keyWord886Translated;
      this.pdf_parameters.provinceCode = this.provinceCodeTranslated;
      this.pdf_parameters.cityCode = this.cityCodeTranslated;

      this.total_loaded = 0;
      this.locale = this.$i18n.locale;
      this.services_loading = [];
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        if (response.data.persons) {
          this.pdf_parameters.searcher_full_name =
            response.data.persons.given_name +
            " " +
            response.data.persons.middle_name +
            " " +
            response.data.persons.last_name;
        }
      });
      console.log(this.services);
      this.services.forEach((obj) => {
        var srv = {};
        srv.service = obj;
        srv.loading_step = 0;
        this.services_loading.push(srv);
      });
      console.log(this.services_loading);

      axios.get(window.base + "/account/balance").then((response) => {
        this.user_balance = parseFloat(response.data);
        if (isNaN(this.user_balance)) this.user_balance = 0;

        var message = "";
        var price = 0;
        this.services.forEach((serv) => {
          price += this.prices[serv];
        });
        if (this.services.length > 1) {
          var names = this.service_codes
            .map((obj) => {
              if (this.services.includes(obj.value)) return obj.display_text;
            })
            .join(",");
          message =
            this.$t("message.find_partner.cn_bulk_services_alert").replace(
              "{}",
              names,
            ) +
            " " +
            window.rubFormat(price, this.currency);
        } else {
          var name = this.service_codes.find((obj) => {
            return obj.value === this.services[0];
          });
          message =
            this.$t("message.find_partner.cn_single_service_alert").replace(
              "{}",
              name.display_text,
            ) +
            " " +
            window.rubFormat(price, this.currency) +
            ". " +
            this.$t("message.account.you_have") +
            " " +
            window.rubFormat(this.user_balance, this.currency);
        }
        if (this.user_balance < price || this.user_balance <= 0) {
          this.$bvModal.msgBoxOk(
            this.$t("message.account.not_enough_funds_message"),
            {
              title: this.$t("message.confirm"),
              size: "md",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            },
          );
        } else {
          this.$bvModal
            .msgBoxConfirm(message, {
              title: this.$t("message.confirm"),
              size: "md",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: this.$t("message.yes"),
              cancelTitle: this.$t("message.no"),
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then(async (value) => {
              if (value) {
                this.disableSearchForSomeTime();

                let fd = new FormData();
                if (isNaN(price)) price = 0;
                fd.append("amount", price);
                fd.append("service_code", this.services.join(","));
                fd.append("search_keyword", this.keyWord886);
                this.reduceBalanceData = (await axios.post(window.base + "/account/reduceBalance", fd)).data;
                this.reduceBalanceId = this.reduceBalanceData?.id || null;

                if (this.reduceBalanceData?.isAccountBalanceLow) {
                  this.$bvModal.msgBoxOk(this.$t("message.message.account_balance_is_low", { balance: window.rubFormat(this.reduceBalanceData.accountBalance, this.currency) }), {
                    title: this.$t("message.confirm"),
                    size: "md",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: this.$t("message.ok"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                  });
                }

                this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
                this.$root.$emit("reduceBalance", { price: price });
                this.startTimer();
                this.loading = this.services.length;
                this.total_loaded++;

                switch (this.locale) {
                  case "cn":
                    this.locale = "zh";
                    break;
                  case "en":
                    this.locale = "en";
                    break;
                  case "ru":
                    this.locale = "ru";
                    break;
                }
                if (this.locale == "ru") {
                  let paramArray = [];
                  paramArray.push(this.keyWord);
                  paramArray.push(this.keyWord886);
                  paramArray.push(this.provinceCode);
                  paramArray.push(this.cityCode);
                  axios
                    .post(
                      window.base +
                      "/translate/TranslateNextArray?source=ru&target=en",
                      paramArray,
                    )
                    .then((res) => {
                      let translatedParams = res.data.filter((trn) => {
                        if (JSON.parse(trn).translation)
                          return JSON.parse(trn).translation;
                      });

                      this.keyWordTranslated = this.keyWord;
                      this.keyWord886Translated = this.keyWord886;
                      this.provinceCodeTranslated = this.provinceCode;
                      this.cityCodeTranslated = this.cityCode;
                      this.requestServices();
                    });
                } else {
                  this.keyWordTranslated = this.keyWord;
                  this.keyWord886Translated = this.keyWord886;
                  this.provinceCodeTranslated = this.provinceCode;
                  this.cityCodeTranslated = this.cityCode;
                  this.requestServices();
                }
              }
            });
        }
      });
    },

    /*async*/ groupAnnualResults(results) {
      console.log("group");
      console.log(results);
      return new Promise((resolve, reject) => {
        console.log("before");
        console.table(results);

        results = results.map((result) => {
          for (let key in result) {
            let data = result[key];
            if (typeof data !== "object") {
              console.log("string", data);
              result[key] = data;
            } else {
              console.warn(key);
              if (
                key == "BasicInfoData" ||
                key == "AssetsData" ||
                key == "SocialInsurance"
              ) {
                if (Array.isArray(data)) {
                  const data_ = {};
                  console.log("not string");
                  data.forEach((item) => {
                    console.log("item", item);
                    data_[item.Key] = item.Translated;
                  });
                  result[key] = data_;
                }
              } else {
                result[key] = data;
              }
            }
          }
          return result;
        });
        console.log("after");
        console.table(results);
        /*await*/ results.forEach(
          /*async*/(result) => {
            if (
              Object.keys(this.annual_info_data).indexOf(
                result.BasicInfoData.RegNo,
              ) == -1
            ) {
              this.annual_info_data[result.BasicInfoData.RegNo] = {
                basic_info: result.BasicInfoData,
                results: [result],
              };
            } else {
              this.annual_info_data[result.BasicInfoData.RegNo].results.push(
                result,
              );
            }
          },
        );
        resolve();
      });
    },
    searchenterpriseFuzzy(mode) {
      let page = 1;
      if (mode !== "new-page") {
        this.enterprise_fuzzy_complete = false;
        this.addLoading("886");
      } else {
        this.progress_fuzzy = 1;
        page = this.business_fuzzy_info.Paging.PageIndex + 1;
      }
      axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=886&signalRConnectionId=${window.signalRConnectionId}&keyWord=` +
          this.keyWord886Translated +
          "&provinceCode=" +
          this.provinceCodeTranslated +
          "&cityCode=" +
          this.cityCodeTranslated +
          "&pageIndex=" +
          page,
        )
        .then((response) => {
          // this.logServiceRequest('886', this.keyWord886 + ' ' + this.provinceCode + ' ' + this.cityCode, response.data);
          var result = response.data.Result;
          if (mode !== "new-page") this.addLoading("886");
          else this.progress_fuzzy = 2;

          if (!result) {
            this.hasResults("886", false);
            if (mode !== "new-page") {
              this.loading--;
              this.no_result++;
            } else this.progress_fuzzy = 3;

            this.logServiceRequest(
              "886",
              this.keyWord886 + " " + this.provinceCode + " " + this.cityCode,
              {},
              {},
            );
            return;
          }
          this.hasResults("886", true);
          var tmp = [];
          this.formatArrayObjectTables(response.data.Result, tmp, "886").then(
            (res) => {
              if (mode !== "new-page") {
                this.addLoading("886");
                this.business_fuzzy_info.response_info = tmp;
              } else {
                this.progress_fuzzy = 3;
                this.business_fuzzy_info.response_info.push(...tmp);
              }

              this.business_fuzzy_info.Paging = response.data.Paging;
              this.business_fuzzy_info.currency = this.currency;
              this.business_fuzzy_info.price = this.prices["886"];
              this.enterprise_fuzzy_complete = true;
              this.pdf_document.business_fuzzy_info = this.business_fuzzy_info;
              this.logServiceRequest(
                "886",
                this.keyWord886 + " " + this.provinceCode + " " + this.cityCode,
                this.business_fuzzy_info,
                response.data,
              );
              if (mode !== "new-page") this.loading--;
            },
          );
        })
        .catch(() => {
          this.hasResults("886", false);
          if (mode !== "new-page") {
            this.loading--;
            this.addLoading("886");
          } else this.progress_fuzzy = 3;

          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.fuzzy_search_cn"),
              ) +
              this.keyWord886 +
              " " +
              this.provinceCode +
              " " +
              this.cityCode,
            timeout: 5000,
          }).show();
        });
    },

    searchAnnualInfo() {
      this.addLoading("213");
      this.anual_search_complete = false;
      axios
        axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=213&signalRConnectionId=${window.signalRConnectionId}&keyWord=` +
          this.keyWord886Translated +
          "&pageIndex=" +
          this.page,
        )
        .then((response) => {
          this.addLoading("213");

          var result = response.data.Result;
          if (typeof response.data.Result !== "object") {
            this.hasResults("213", false);
            console.log("serv213conf");
            this.addLoading("213");

            this.no_result++;
            this.logServiceRequest("213", this.keyWord, {}, {});
            this.loading--;
            return;
          }
          this.hasResults("213", true);

          if (
            response.data.Result.BasicInfoData &&
            response.data.Result.BasicInfoData.CompanyName
          )
            this.tmp_company_info_for_helpers.EnglishName =
              response.data.Result.BasicInfoData.CompanyName;
          else
            this.tmp_company_info_for_helpers.EnglishName =
              this.keyWordTranslated;

          if (
            response.data.Result.ContactInfo &&
            response.data.Result.BasicInfoData.EmailAddress
          )
            this.tmp_company_info_for_helpers.Email =
              response.data.Result.BasicInfoData.EmailAddress;
          else this.tmp_company_info_for_helpers.Email = false;
          console.log("before trans");
          console.table(result);

          let result_ = result.map((item) => {
            const year = item.Year;
            const no = item.No;
            const date = item.PublishDate;

            if (typeof item.AssetsData !== "object") item.AssetsData = {};
            item.AssetsData.Year = year;
            item.AssetsData.No = no;
            item.AssetsData.PublishDate = date;
            if (typeof item.BasicInfoData !== "object") item.BasicInfoData = {};
            item.BasicInfoData.Year = year;
            item.BasicInfoData.No = no;
            item.BasicInfoData.PublishDate = date;
            if (typeof item.SocialInsurance !== "object")
              item.SocialInsurance = {};
            item.SocialInsurance.Year = year;
            item.SocialInsurance.No = no;
            item.SocialInsurance.PublishDate = date;

            item.BranchList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.EmployeeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.InvestInfoList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ProvideAssuranceList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.StockChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            return item;
          });
          console.warn("RES", result_);
          this.getAnnualTranslations(result_).then((r) => {
            this.addLoading("213");

            this.groupAnnualResults(r).then((re) => {
              this.anual_search_complete = true;
              this.loading--;
              this.pdf_document.annual_info_data = this.annual_info_data;
              this.logServiceRequest(
                "213",
                this.keyWord,
                this.annual_info_data,
                response.data,
              );
            });
          });
        })
        .catch(() => {
          this.hasResults("213", false);
          this.addLoading("213");
          this.loading--;
          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.contragent_search.annual_report"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchRiskScanInfo() {
      this.addLoading("736");
      this.risk_search_complete = false;
      axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=736&signalRConnectionId=${window.signalRConnectionId}&keyWord=` +
          this.keyWord886Translated
        )
        .then((response) => {
          this.addLoading("736");

          if (!response.data.Result) {
            this.hasResults("736", false);
            this.addLoading("736");
            this.loading--;
            this.no_result++;
            this.logServiceRequest("736", this.keyWord, {}, {});
            return;
          }
          this.hasResults("736", true);

          this.tmp_company_info_for_helpers.EnglishName =
            response.data.Result.Name;
          if (
            response.data.Result.ContactInfo &&
            response.data.Result.ContactInfo.Email
          )
            this.tmp_company_info_for_helpers.Email =
              response.data.Result.ContactInfo.Email;
          else this.tmp_company_info_for_helpers.Email = false;

          var locale = this.$i18n.locale;
          var tmp = Object.entries(response.data.Result);
          tmp = tmp.filter(
            (item) => typeof item[1] !== "object" && !_.isArray(item[1]),
          );
          var stringValues = tmp.map((str) => {
            return str[1];
          });
          var stringKeys = tmp.map((str) => {
            return str[0];
          });
          this.formatStringValues(stringValues, stringKeys);
          if (locale !== "cn") {
            this.getRiskScanTranslations(
              response,
              stringValues,
              stringKeys,
            ).then((res) => {
              this.addLoading("736");
              this.risk_search_complete = true;
              this.pdf_document.risk_info_data = this.risk_info_data;
              this.logServiceRequest(
                "736",
                this.keyWord,
                this.risk_info_data,
                response.data,
              );
              this.loading--;
            });
          } else {
            this.risk_info_data = response.data.Result;
            this.risk_search_complete = true;
            this.pdf_document.risk_info_data = this.risk_info_data;
            this.loading--;
          }
        })
        .catch(() => {
          this.hasResults("736", false);
          this.loading--;
          this.addLoading("736");
          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.contragent_search.enterprise_risk_scan"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchNewsInfo() {
      this.news_search_complete = false;
      this.addLoading("701");

      axios
        .get("https://attis.topwoniu.com/library/openAPINews?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          if (!response.data.Result) {
            this.hasResults("701", false);
            this.addLoading("701");
            this.logServiceRequest("701", this.keyWord, {}, {});
            this.no_result++;
            this.loading--;
            return;
          }
          this.hasResults("701", true);

          this.tmp_company_info_for_helpers.EnglishName =
            this.keyWordTranslated;
          this.tmp_company_info_for_helpers.Email = false;

          var tmp = [];
          this.formatArrayObjectTables(response.data.Result, tmp).then(
            (res) => {
              this.addLoading("701");

              this.news_info_data.response_info = tmp;

              this.news_search_complete = true;
              this.pdf_document.news_info_data = this.news_info_data;
              this.logServiceRequest(
                "701",
                this.keyWord,
                this.news_info_data,
                response.data,
              );
              setTimeout(() => {
                this.loading--;
              }, 5000);
            },
          );
        })
        .catch(() => {
          this.hasResults("701", false);
          this.loading--;
          this.no_result++;
          this.addLoading("701");

          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.corporate_news_search"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchCourtInfo() {
      this.court_search_complete = false;
      this.addLoading("930");
      axios
        .get("https://attis.topwoniu.com/library/openAPIQCC?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          this.addLoading("930");

          if (
            response.data.Result.VerifyResult == 1 &&
            response.data.Result.Data.length > 0
          ) {
            this.hasResults("930", true);
            this.tmp_company_info_for_helpers.EnglishName =
              this.keyWordTranslated;
            this.tmp_company_info_for_helpers.Email = false;

            response.data.Result.Data.map((item) => {
              if (item.ProsecutorList.length > 0) {
                item.ProsecutorList = item.ProsecutorList.map((value) => {
                  return value.Name;
                }).join(",");
              }

              if (item.DefendantList.length > 0) {
                item.DefendantList = item.DefendantList.map((value) => {
                  return value.Name;
                }).join(",");
              }

              return item;
            });
            var tmp = {};
            tmp.Data = [];
            this.formatArrayObjectTables(
              response.data.Result.Data,
              tmp.Data,
            ).then((res) => {
              this.addLoading("930");

              //console.log('court 1')

              this.court_search_complete = true;
              this.court_info_data.response_info = tmp;
              this.court_info_data.response_info.VerifyResult =
                response.data.Result.VerifyResult;
              this.pdf_document.court_info_data = this.court_info_data;
              this.logServiceRequest(
                "930",
                this.keyWord,
                this.court_info_data,
                response.data,
              );
              setTimeout(() => {
                this.loading--;
              }, 5000);
            });
          } else {
            this.hasResults("930", false);
            this.addLoading("930");
            this.no_result++;
            this.logServiceRequest("930", this.keyWord, {}, {});
            this.loading--;
            return;
          }
        })
        .catch(() => {
          this.hasResults("930", false);
          this.addLoading("930");
          this.no_result++;
          this.loading--;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.court_notice_info"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchCompanyInfo() {
      this.addLoading("430");

      axios
        .get("https://attis.topwoniu.com/library/openAPIQCC?keyWord=" + this.keyWordTranslated)
        .then((response) => {
          this.addLoading("430");
          if (!response.data.Result) {
            this.hasResults("430", false);
            this.addLoading("430");
            this.no_result++;
            this.loading--;
            this.logServiceRequest("430", this.keyWord, {}, {});
            return;
          }
          this.hasResults("430", true);
          var tmp_response_info = response.data.Result;

          this.tmp_company_info_for_helpers.EnglishName =
            response.data.Result.Name;
          this.tmp_company_info_for_helpers.Email = response.data.Result.Email;

          if (tmp_response_info.ChangeList.length > 0) {
            tmp_response_info.ChangeList.forEach((chg) => {
              if (typeof chg.BeforeList !== "string")
                chg.BeforeList = chg.BeforeList.join(",");
              if (typeof chg.AfterList !== "string")
                chg.AfterList = chg.AfterList.join(",");
            });
          }

          var tmp_service_info = Object.entries(response.data.Result);

          tmp_service_info = tmp_service_info.filter(
            (item) =>
              typeof item[1] !== "object" && !_.isArray(item[1]) && item[1],
          );

          // Translating packages of text (columns of tables)
          var service_to_translate = [];
          tmp_service_info.forEach(([key, value]) => {
            service_to_translate.push(value);
          });

          this.getCompanyInfoTranslations(
            service_to_translate,
            tmp_service_info,
            tmp_response_info,
          ).then((r) => {
            this.addLoading("430");

            this.loading--;
            console.log("company 1");

            this.search_company_info_complete = true;
            this.company_info_data.response_info = tmp_response_info;
            this.pdf_document.company_info_data = this.company_info_data;
            this.logServiceRequest(
              "430",
              this.keyWord,
              this.company_info_data,
              response.data,
            );
          });
        })
        .catch(() => {
          this.hasResults("430", false);
          this.no_result++;
          this.loading--;
          this.addLoading("430");
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.common_info_cn"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    logServiceRequest(service_code, search_text, result, result_cn) {
      var requestlog = {};
      requestlog.service_code = service_code;
      requestlog.search_text = search_text;
      requestlog.result = result;

      this.global_log[service_code] = requestlog;
      this.global_log_cn[service_code] = result_cn;
      this.global_kw = search_text;

      // axios.post(window.base + '/contract/saveContrHistory', requestlog).then(ter => {

      // })
    },
    sendLog() {
      let requestlog = {};
      requestlog.service_code = Object.keys(this.global_log).join(",");
      requestlog.search_text =
        this.formatted_kw != "" ? this.formatted_kw : this.global_kw;
      requestlog.result = JSON.stringify(this.global_log);
      requestlog.china_result = JSON.stringify(this.global_log_cn);
      axios
        .post(window.base + "/contract/saveContrHistory", requestlog)
        .then((response) => {
          this.history_record_id = response.data;
        });
    },
    addLoading(service_code) {
      console.log("serv_code", service_code);
      console.log("servic", this.services_loading);
      var service = this.services_loading.find(
        (element) => parseInt(element.service) == parseInt(service_code),
      );
      console.log("serv", service);
      service.loading_step++;
      this.total_loaded++;
    },
    startTimer() {
      var sec = 0;
      this.interval = setInterval(() => {
        this.timer_seconds = this.pad(++sec % 60);
        this.timer_minutes = this.pad(parseInt(sec / 60, 10));
      }, 1000);
    },
    pad(val) {
      return val > 9 ? val : "0" + val;
    },
    noResultsLabel() {
      let services_array = [];
      this.services_loading.forEach((srvc) => {
        services_array.push(
          this.$t("message.find_partner.service_" + srvc.service),
        );
      });
      let keyWords = [];
      if (this.keyWord) keyWords.push(this.keyWord);
      if (this.keyWord886) keyWords.push(this.keyWord886);
      if (this.provinceCode) keyWords.push(this.provinceCode);
      if (this.cityCode) keyWords.push(this.cityCode);

      return this.$t("message.find_partner.no_results")
        .replace("[services]", services_array.join(","))
        .replace("[parameters]", keyWords.join(","));
    },
  },
  computed: {
    locale_() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
        case "ru":
          locale = "ru-RU";
          break;
      }
      return locale;
    },
    user_full_name() {
      return (
        this.$store.state.user.firstName + " " + this.$store.state.user.lastName
      );
    },
    is_bank() {
      return window.is_bank;
    },
    showKeyWord() {
      //console.log('checking');
      //console.log(this.services.length, this.services[0])
      if (this.services.length == 1 && this.services[0] == 886) return false;
      return true;
    },
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.doMount();
      },
    },
    keyWord() {
      window.is_searched = true;
    },
    keyWord886() {
      window.is_searched = true;
    },
    loading: function (newVal, oldVal) {
      if (oldVal > 0 && newVal <= 0) {
        clearInterval(this.interval);
        this.sendLog();
      }
    },
  },
};
</script>
<style>
.service-icon-holder {
  min-width: 100px;
  min-height: 100px;
  max-height: 100px;
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  background: rgba(0, 123, 255, 0.3);
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
}

.service-icon-holder span.api-id {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: 5px;
  left: 5px;
  right: 5px;
  text-align: center;
}

.service-text-holder {
  flex-basis: 100%;
}

.service-text-holder .service-title {
  font-weight: bold;
}

.service-text-holder .service-description {
  font-size: 13px;
}

.checkbox-holder {
  width: 30px;
  height: 100px;
  display: flex;
  justify-content: center;
}

.api-price {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: -20px;
  left: 5px;
  right: 5px;
  text-align: center;
}

.view-compact .service-icon-holder {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
}
</style>
<style>
.modal-dialog.modal-sm.modal-dialog-centered .modal-body {
  font-size: 18px;
}

.modal-dialog.modal-sm.modal-dialog-centered .modal-footer .btn {
  font-size: 18px;
  padding: 10px 20px;
}

#keyword::placeholder {
  color: #ccc;
  font-size: 15.2px;
}
</style>

<style>
.hyperlink {
  cursor: pointer !important;
}

.dedede {
  display: flex;
  gap: 24px;
  position: relative;
}

.dedede .translator {
  flex-basis: 100%;
}

.dedede input {
  flex-basis: 100%;
  box-shadow:
    0px 12px 32px rgba(0, 0, 0, 0.04),
    0px 8px 24px rgba(0, 0, 0, 0.04),
    0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.08);
  border-radius: 30px;
  padding: 14px 44px;
  border: 0;
}

.dedede .translator input::placeholder {
  color: #797980 !important;
}

.dedede button {
  padding: 14px 40px;
  background: linear-gradient(90deg, #259fe2 0%, #46b1e2 100%);
  border-radius: 30px;
  border: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-items: center;

  color: #ffffff;
}

.dedede .icon {
  left: 15px;
  position: absolute;
  z-index: 4;
}
</style>
